import React from "react";
// import About from "./About";
// import Experience from "./experience/Experience.jsx";
import Project from "./project/Project.jsx";
// import Extra from "./extra-curricular/Extra.jsx";
// import SideNavbar from '../common/SideNavbar';
import OtherProjects from "./other-project/OtherProjects.jsx";
import Skills from "./Skill.jsx";
import Muay from "./muay-thai/Muay.jsx";

const Main = () => {
  return (
    <>
      <main id="main-wrapper" className="h-fit w-full relative overflow-hidden">
        <article
          id="main-container"
          className="h-fit w-full lg:w-[75vw] py-6 px-12"
        >
          <section id="project-section">
            <Project />
          </section>
          <section id="other-project-section">
            <OtherProjects />
          </section>
          {/* <section id="extra-section">
            <Extra />
          </section> */}
          <section id="skill-section">
            <Skills />
          </section>
          <section id="muay-thai-section">
            <Muay />
          </section>
        </article>
        {/* <SideNavbar /> */}
      </main>
    </>
  );
};

export default Main;
